<style lang="less">
  @import "./css/common.less";
</style>
<template>
  <div class="contact common-content">
    <navMenu></navMenu>
    <div class="content">
      <div class="banner-items">
        <img src="../assets/images/banner_Contactus.jpg">
        <div class="banner-title font-large">
          <span>CONTACT US</span>
        </div>
      </div>
      <div class="text-content">
        <div class="pc-items">
          <ContactBox></ContactBox>
        </div>
        <div class="article">
          <div class="bread-crumbs">
            <span class="pointer" @click="goToIndex">HOME></span>
            <span>CONTACT US</span>
          </div>
          <span class="article-title">Lake Tai Apparel Pty Ltd</span>
          <div class="article-content">
              <div class="row-items">
                  <span>ACN:</span>632803055
              </div>
              <div class="row-items">
                  <span>ADD:</span>1st Floor, 35, 209 Toorak Road, South Yarra, VIC 3141, Australia.
              </div>
              <div class="row-items">
                  <span>TEL:</span>0423585188
              </div>
              <div class="row-items">
                  <span>Email:</span>sales@laketaiapparel.com.au
              </div>
          </div>
          <div class="mb-items">
            <ContactBox></ContactBox>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import NavMenu from '../components/navMenu'
import Footer from '../components/footer'
import ContactBox from '../components/contactBox'
export default {
  data () {
    return {
    }
  },
  components: {
    NavMenu,
    Footer,
    ContactBox
  },
  methods: {
    goToIndex(){
      this.$router.push('/index')
    }
  },
  watch: {},
  mounted () {
    
  }
}
</script>
<style lang="less">
  .contact{
    .article-content{
        .row-items:first-child{
            margin-top: 15px;
        }
        .row-items{
            margin-bottom: 10px;
            span{
                color: #0073af;
                margin-right: 10px;
            }
        }
    }
  }
</style>
